import { AxiosWrapper } from "src/app/shared/utils/axios.wrapper";

export class CompCodeService {
    static async getCompCodes(): Promise<any> {
        const response = await AxiosWrapper.get('/api/PslLocationCompanies/GetPendingToCreateLocationCompanies');
        return response.data;
    }
}